import { useState, useEffect } from "react";
import useWebSocket from "react-use-websocket";

export const useWebsocketFetchInvoices = ({ onSuccessInvoices }) => {
  const [socketUrl, setSocketUrl] = useState(null);
  const [statusInvoices, setStatus] = useState("off");
  const [dataInvoices, setData] = useState([]);

  const { sendJsonMessage, lastJsonMessage } = useWebSocket(socketUrl, {
    onOpen: () => {
      // console.log(`Connected to App WS invoices`);
      setStatus("on");
      setData([]);
    },
    onClose: () => {
      // console.log("close invoices");
      if (
        (dataInvoices?.length === 0 && statusInvoices === "fetching") ||
        (dataInvoices?.length === 1 &&
          (dataInvoices[0]?.MessageResponse === "Nenhum registro localizado." ||
            dataInvoices[0]?.MessageResponse ===
              "Falha em validação de filtros!"))
      ) {
        setStatus("empty");
      }

      if (dataInvoices.length !== 0) {
        onSuccessInvoices(dataInvoices);
        setStatus("off");
      }
      setData([]);
    },
    onError: () => {
      // console.log('erro');
      setStatus("error");
    },
    shouldReconnect: () => true,
    reconnectInterval: 2000,
  });

  const handleFetchDataInvoices = (data) => {
    // console.log("data request invoices", data);
    setStatus("fetching");
    sendJsonMessage(data);
  };

  const handleFetchUrlInvoices = (url) => {
    setSocketUrl(url);
  };

  const onMessageReceive = (response) => {
    // console.log("response invoices-->", response);
    if (
      !response?.Result ||
      response?.message === "Forbidden" ||
      response?.Result[0]?.MessageResponse === "Nenhum registro localizado." ||
      response?.Result[0]?.MessageResponse === "Falha em validação de filtros!"
    ) {
      setStatus("empty");
      return;
    }

    setData([...dataInvoices, ...response?.Result]);
  };

  useEffect(() => {
    if (lastJsonMessage) {
      onMessageReceive(lastJsonMessage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastJsonMessage]);

  return {
    handleFetchDataInvoices,
    handleFetchUrlInvoices,
    dataInvoices,
    statusInvoices,
  };
};
